import React from 'react';

import { SItemsContainer } from './styles';

import { H2 } from '../../atoms/Typography';
import Button from '../../atoms/Button';
import Section from '../../layout/Section';
import SquareGenerator from '../../molecules/SquareGenerator';
import IconItem from './IconItem';

const SectionIconItems = ({
    config,
    titleUnderline = false,
    background = '',
}) => {
    const {
        title,
        id,
        content,
        cta,
        handleCta,
        squares,
        forwardedRef,
    } = config;

    return (
        <Section
            background={ background }
            forwardedRef={ forwardedRef }
            id={ id }
        >
            <H2 titleUnderline={ titleUnderline }>
                { title }
            </H2>
            <SItemsContainer>
                {
                    content.map(({
                        Icon,
                        description
                    }, index)=> (
                        <IconItem
                            key={ index }
                            Icon={ Icon }
                            description={ description }
                        />
                    ))
                }
            </SItemsContainer>
            {
                cta && (
                    <Button onClick={ handleCta }>
                        { cta }
                    </Button>
                )
            }
            {
                !!squares && <SquareGenerator squares={ squares }/>
            }
        </Section>
    );
};

export default SectionIconItems;
